import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { Link } from "react-router-dom";
const navbar = () => (
  <Navbar bg="dark" variant="dark" expand="lg">
    <Navbar.Brand as={Link} to={"/"}>A* Technologies </Navbar.Brand>
    <Navbar.Toggle aria-controls="basic-navbar-nav" />
    <Navbar.Collapse id="basic-navbar-nav">
      <Nav className="mr-auto">
        <Nav.Link as={Link} to={"/"}>Home</Nav.Link>
        <Nav.Link as={Link} to={"/about"}>About Us</Nav.Link>
        <Nav.Link as={Link} to={"/industries"}>Solutions</Nav.Link>
        <Nav.Link as={Link} to={"/news"}>News</Nav.Link>
        <Nav.Link as={Link} to={"/contact"}>Contact Us</Nav.Link>
        <Nav.Link href="https://vibe.astartech.ai/" target="_blank">Vibe Platform</Nav.Link>
      </Nav>
    </Navbar.Collapse>
  </Navbar>
);
export default navbar;